import { useState } from "react"
import { ChevronDown } from "lucide-react"
import "./cmistyle.css"

export default function LearningOutcomes() {
  const [openItems, setOpenItems] = useState({})

  const toggleItem = (id) => {
    setOpenItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }))
  }

  const learningOutcomes = [
    {
      id: 1,
      title: "الممارسة التأملية والتطوير الشخصي",
      description: (
        <ul>
         <li>تطبيق تقنيات الممارسة التأملية لتقييم وتحسين الأداء الشخصي والمهني.         </li>
       <li>تطوير الوعي الذاتي وخطط التحسين المستمر بناءً على الرؤى التأملية.       </li>
        </ul>
      ),
    },
    {
      id: 2,
      title: "اتخاذ القرارات المستندة إلى البيانات",
      description: (
        <ul>
        <li>استخدام البيانات والمعلومات بشكل فعال لتوجيه القرارات الاستراتيجية والتشغيلية.
        </li>
        <li>تحليل وتفسير البيانات المالية وغير المالية لدعم الأهداف التجارية.
        </li>
        </ul>
      ),
    },
    {
      id: 3,
      title: "  إدارة تجربة العملاء",
      description: (
        <ul>
         <li>تصميم وتنفيذ استراتيجيات لتحسين تجربة العملاء عبر نقاط الاتصال المختلفة.</li>
         <li>تعزيز ثقافة تركز على العملاء داخل المنظمة لزيادة رضا العملاء وولائهم.
         </li>
        </ul>
      ),
    },
    {
      id: 4,
      title: " إدارة التغيير",
      description: (
        <ul>
         <li>قيادة وإدارة مبادرات التغيير التنظيمي بنجاح.</li>
         <li>تطبيق نظريات ونماذج إدارة التغيير للتخطيط والتنفيذ والحفاظ على التغيير.
         </li>
        </ul>
      ),
    },
    {
      id: 5,
      title: "التدريب والإرشاد",
      description: (
        <ul>
          <li>تقديم برامج تدريب وإرشاد فعالة لتطوير قدرات الأفراد والفريق.
          </li>
          <li>استخدام تقنيات التدريب والإرشاد لتحسين الأداء والتطوير المهني.
          </li>
        </ul>
      ),
    },
    {
      id: 6,
      title: "إدارة علاقات الأطراف المعنية",
      description: (
        <ul>
        <li>تحديد وتحليل وإدارة العلاقات مع الأطراف المعنية الداخلية والخارجية.
        </li>
        <li>تطوير استراتيجيات للتواصل الفعال مع الأطراف المعنية لتحقيق الأهداف التنظيمية.
        </li>
        </ul>
      ),
    },
    {
      id: 7,
      title: "إدارة الابتكار",
      description: (
        <ul>
         <li>تعزيز ثقافة الابتكار والإبداع داخل المنظمة.
         </li>
         <li>تطبيق مبادئ الابتكار لتطوير منتجات وخدمات وعمليات جديدة.
         </li>
        </ul>
      ),
    },
    {
      id: 8,
      title: "إدارة المالية",
      description: (
        <ul>
         <li>فهم وتطبيق مبادئ إدارة المالية الرئيسية لدعم الاستراتيجية التجارية.
         </li>
         <li>تطوير وإدارة الميزانيات والتنبؤات والخطط المالية لضمان الصحة المالية للمنظمة.
         </li>
        </ul>
      ),
    },
    {
      id: 9,
      title: "تنفيذ المشاريع الإدارية",
      description: (
        <ul>
          <li>تخطيط وتنفيذ وتقديم مشروع إداري يعالج حاجة أو تحدي تنظيمي محدد.
          </li>
          <li>استخدام منهجيات البحث لجمع وتحليل البيانات، واستخلاص النتائج، وتقديم التوصيات.</li>
        </ul>
      ),
    },
    {
      id: 10,
      title: "المساواة والتنوع والشمول",
      description: (
        <ul>
       <li>تعزيز وإدارة المساواة والتنوع والشمول داخل مكان العمل.
       </li>
       <li>تطوير وتنفيذ السياسات والممارسات التي تعزز ثقافة تنظيمية شاملة.
       </li>
        </ul>
      ),
    },
  ]

  return (
    <div className="learning-outcomes-container">
    
      <h2 className="services-header after:w-20 after:-bottom-2 text-center m-auto mb-4 mt-4">
      مخرجات التعلم        </h2>
      <p className="learning-outcomes-subtitle mb-2">عند إكمال برنامج المدير المعتمد سيتمكن المشاركون من</p>

      <div className="learning-outcomes-grid">
        {learningOutcomes.map((item) => (
          <div key={item.id} className="learning-outcome-item" onClick={() => toggleItem(item.id)}>
            <div className="learning-outcome-header">
              <span>{item.title}</span>
              <ChevronDown className={`chevron-icon ${openItems[item.id] ? "rotate" : ""}`} size={20} />
            </div>
            {openItems[item.id] && (
              <div className="learning-outcome-content">
                {item.description}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
